/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [stomp-client.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 24.09.18 14:02
 */

// using compatibility mode because of issues with new api as of V6.1.2 (original V4.0.8)
// import * as StompJs from '@stomp/stompjs/esm6';
import * as StompJs from '../../vendor/stompjs-compat/compat-stomp';
import SockJS from 'sockjs-client/dist/sockjs';
import {getBearer} from "../../actions/local-storage";
import {getStompServerUrl} from "../../actions/environment";
import {notifyError} from "../notifications/notify";

// spring broker syntax - disabled in favor of rabbitmq
const SUBSCRIBE_EVENT_GENERIC_SPRING_BROKER = "/user/topic/event/generic";
const SUBSCRIBE_SIMPLE_CHAT_SPRING_BROKER = "/user/topic/chat/simple";

// rabbitmq syntax - currently the default server broker
const SUBSCRIBE_EVENT_GENERIC = "/user/topic/event-generic";
const SUBSCRIBE_SIMPLE_CHAT = "/user/topic/chat-simple";

export const SEND_GENERIC_QUEUE = "/app/message";
export const CHAT_DELIVER_QUEUE = "/app/chat/deliver";
export const CHAT_CONSUME_QUEUE = "/app/chat/consume";

function stompClient() {
    let client = null;
    let state = 'DISCONNECTED';

    return {

        connect: (username, eventhandler, chathandler) => {
            if (state === 'CONNECTING') return;
            const bearer = getBearer();
            const headers = {
                'X-Authorization': bearer ? 'Bearer ' + bearer.token : null,
                login: username,
                passcode: null
            };

            state = 'CONNECTING';
            client = StompJs.Stomp.over(() => new SockJS(getStompServerUrl()));
            client.reconnect_delay = 10000;
            client.heartbeatIncoming = 60000;
            client.heartbeatOutgoing = 60000;

            client.connect(headers, (frame) => {
                eventhandler && client.subscribe(SUBSCRIBE_EVENT_GENERIC, (frame) => {
                    eventhandler(JSON.parse(frame.body));
                });
                chathandler && client.subscribe(SUBSCRIBE_SIMPLE_CHAT, (frame) => {
                    chathandler(JSON.parse(frame.body));
                });
                state = 'CONNECTED';

            }, (error) => {
                // TODO possible security issues - force logout ?
                state = 'DISCONNECTED';
                console.log(error);
                notifyError(`WEBSOCKET error. ${error}`);
            });

            client.debug = (...messages) => {};
        },
        subscribe: (topic, callback) => {
            state === 'CONNECTED' &&  client.subscribe(topic, (frame) => {
                callback(JSON.parse(frame.body));
            });
        },
        disconnect: () => {
            state === 'CONNECTED' && client.disconnect();
            state = 'DISCONNECTED';
        },
        send: (queue, message) => {
            state === 'CONNECTED' && client.send(queue, {}, JSON.stringify(message));
        },
        state: () => {return state}
    }
}

// init function before exporting
export default stompClient();